import React from 'react';

export default class Loading extends React.Component {
	constructor(props) {
    super(props);
  }

  render () {
    return (
      <div className="">
        <div className="jhc-loading-area">
          <div className="jhc-loading-svg"></div>
        </div>
      </div>
    )
  }
}